export default {
    account_api_keys_tab_name: 'Nombre',
    account_api_keys_tab_api_key: 'Llave de API',
    account_api_keys_tab_rate_limit_plan: 'Plan de Límite de Tasa',
    account_api_keys_tab_rate_limit: 'Límite de Tasa',
    account_api_keys_tab_search_placeholder: 'Buscar por nombre',
    account_api_keys_tab_copy_error: 'No se pudo obtener el valor de la api key',
};
